import { desktopContentMaxWidthOld } from 'layouts/styles';
import { primaryDark, red, white } from '../../themes/colors';
import { secondaryMain } from 'now-frontend-shared/themes/colors';

export default {
  wrapper: {
    flex: 1,
    '@media screen and (max-width: 600px)': {
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
      overflowX: 'hidden',
    },
  },
  darkerTile: {
    background: '#F9F9F9',
  },
  totalContainer: {
    margin: '20px 0',
    textAlign: 'right',
    width: '100%',
    '@media screen and (max-width: 600px)': {
      width: '100% !important',
      marginLeft: '0 !important',
      marginRight: '0 !important',
      textAlign: 'left',
      '& > div': {
        minWidth: '0 !important',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '12px 14px',
      },
      '& > div > div': {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        margin: 0,
        gap: '12px',
      },
    },
  },
  wellsPhoneList: {
    display: 'none',
    '@media screen and (max-width: 600px)': {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      width: '100%',
    },
  },
  wellPhoneCard: {
    border: '1px solid #E5E5E5',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  wellPhoneTitle: {
    padding: '12px 12px 4px',
    fontSize: '16px',
    fontWeight: 600,
    color: '#171721',
  },
  wellPhoneRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: '12px',
    padding: '8px 12px',
    borderTop: '1px solid #E5E5E5',
    fontSize: '14px',
    lineHeight: '20px',
  },
  wellPhoneLabel: {
    color: '#615656',
    flex: '1 1 auto',
  },
  wellPhoneValue: {
    textAlign: 'right',
    fontWeight: 500,
    color: '#171721',
    minWidth: 0,
  },
  wellPhoneBid: {
    padding: '10px 12px 12px',
    borderTop: '1px solid #E5E5E5',
    background: '#F9F9F9',
  },
  wellPhoneBidLabel: {
    display: 'block',
    marginBottom: '6px',
    color: '#615656',
    fontSize: '14px',
  },
  container: {
    height: '100%',
    '@media screen and (max-width: 600px)': {
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
    },
  },
  wellsContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(13, 1fr)',
    '@media screen and (max-width: 600px)': {
      width: 'max-content',
      minWidth: '100%',
    },
  },
  wellsTableScroll: {
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    '@media screen and (max-width: 600px)': {
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
    },
  },
  topSection: {
    backgroundColor: primaryDark,
    color: '#fff',
    position: 'sticky',
    top: 0,
    zIndex: '3',
    '@media screen and (max-width: 600px)': {
      position: 'static',
      width: '100%',
      maxWidth: '100%',
      minWidth: 0,
    },
  },
  topSectionContent: {
    maxWidth: desktopContentMaxWidthOld,
    padding: '24px 40px 24px 16px',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',

    '@media screen and (max-width: 960px)': {
      padding: '20px',
    },

    '@media screen and (max-width: 600px)': {
      maxWidth: '100%',
    },
  },
  wellsDesktop: {
    '@media screen and (min-width: 601px)': {
      display: 'none',
    },
  },
  wellsMobile: {
    '@media screen and (max-width: 600px)': {
      display: 'none',
    },
  },
  heading: {
    flex: 1,
    fontSize: '32px',
    lineHeight: '37px',
    fontWeight: 'bold',

    '@media screen and (max-width: 960px)': {
      padding: '12px 0',
      fontSize: '28px',
      lineHeight: '32px',
    },
  },
  wellsCount: {
    color: 'rgba(255, 255, 255, 0.78)',
  },
  id: {
    fontSize: '18px',
    lineHeight: '21px',
    fontWeight: 'bold',
  },
  idNumber: {
    fontWeight: 'normal',
  },
  icon: {
    width: '32px',
    height: '32px',
    margin: '2px 28px 0 16px',
    cursor: 'pointer',
    userSelect: 'none',

    '@media screen and (max-width: 960px)': {
      margin: 'unset',
    },
  },
  buttonGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minWidth: 0,
    maxWidth: '100%',
    '@media screen and (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
    },
  },
  topSectionContainer: {
    padding: '16px 0',
    gap: '20px',
    flexDirection: 'row',
    justifyContent: 'space-between',

    '@media screen and (max-width: 960px)': {
      padding: 'unset',
    },

    '@media screen and (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
      maxWidth: '100%',
    },
  },
  headerMeta: {
    gap: '23px',
    '@media screen and (max-width: 600px)': {
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
      gap: '14px 16px',
      width: '100%',
    },
  },
  headerActions: {
    '@media screen and (max-width: 600px)': {
      width: '100%',
      alignItems: 'stretch',
      gap: '8px',
      '& > *': {
        width: '100%',
      },
    },
  },
  topSectionHeading: {
    fontSize: '18px',
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'column',

    '@media screen and (max-width: 1280px)': {
      marginRight: '16px',
    },

    '@media screen and (max-width: 960px)': {
      flexDirection: 'row',
      alignItems: 'center',
      padding: '12px 0',
    },

    '@media screen and (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginRight: 0,
      padding: 0,
      gap: '2px',
    },
  },
  topHeading: {
    '@media screen and (max-width: 960px)': {
      marginRight: '8px',
    },
    '@media screen and (max-width: 600px)': {
      marginRight: 0,
      fontSize: '13px',
      lineHeight: '18px',
      opacity: 0.75,
    },
  },
  topSectionDescription: {
    marginTop: '8px',
    fontSize: '20px',

    '@media screen and (max-width: 960px)': {
      marginTop: 'unset',
    },
    '@media screen and (max-width: 600px)': {
      marginTop: 0,
      fontSize: '16px',
      lineHeight: '22px',
    },
  },
  mapContainer: {
    position: 'relative',
    height: '600px',
    '@media screen and (max-width: 600px)': {
      width: '100%',
      maxWidth: '100%',
      height: '320px',
      overflow: 'hidden',
      '& [style*="width: 25%"]': {
        display: 'none',
      },
    },
  },
  bottomSectionContent: {
    maxWidth: '1500px',
    padding: '42px 20px',
    gap: '20px',
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',

    '@media screen and (max-width: 960px)': {
      padding: '20px',
    },

    '@media screen and (max-width: 600px)': {
      maxWidth: '100%',
    },
  },
  bottomSections: {
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
  },
  bottomContentContainer: {
    padding: '22px 0',

    '@media screen and (max-width: 960px)': {
      padding: '10px 0',
    },
  },
  bottomSectionHeading: {
    padding: '6px',
    fontSize: '12px',
    lineHeight: '24px',
    fontWeight: '500',
    color: '#000000',
    borderRight: 'solid 1px #E5E5E5',
    borderBottom: 'solid 1px #E5E5E5',

    '@media screen and (max-width: 960px)': {
      padding: '12px 0',
    },
  },
  bottomSectionDescription: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'normal',
  },
  biddingDetailsSectionHeading: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#615656',
  },
  biddingDetailsSectionDescription: {
    marginTop: '8px',
    fontWeight: 'normal',
    fontSize: '14px',
  },
  descriptionSectionHeading: {
    padding: '10px 10px 10px 0',
    fontSize: '17.5px',
    lineHeight: '46px',
    fontWeight: 'bold',
    color: '#615656',
    textAlign: 'center',

    '@media screen and (max-width: 960px)': {
      padding: '12px 0',
    },
  },
  descriptionSectionDescription: {
    marginTop: '8px',
    fontWeight: 'normal',
    textAlign: 'center',
  },
  contentBorders: {
    borderTop: 'solid 1px #E5E5E5',
    borderBottom: 'solid 1px #E5E5E5',
    padding: '8px 0',
  },
  contentHeading: {
    fontSize: '22px',
    fontWeight: '500',
    color: '#000000',
    display: 'flex',
    alignItems: 'center',
    marginTop: '22px',
  },
  contentSubHeading: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#171721',
    marginTop: 8,
  },
  checkIcon: {
    color: '#9DC284',
    marginLeft: 5,
  },
  redText: {
    color: red,
  },
  sellerBidStatus: {
    fontSize: '20px',
    fontWeight: 'normal',
    color: '#FFFFFF',
    marginTop: '8px',

    '@media screen and (max-width: 960px)': {
      marginTop: 'unset',
      marginLeft: '8px',
    },
  },
  notificationText: {
    color: '#B9B9B9',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    marginBottom: '20px',
    textTransform: 'uppercase',
  },
  listingStatus: {
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 'normal',
    color: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    '@media screen and (max-width: 1280px)': {
      marginRight: '16px',
    },

    '@media screen and (max-width: 960px)': {
      display: 'flex',
      alignItems: 'center',
      padding: '12px 0',
    },
    '@media screen and (max-width: 600px)': {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: '8px',
      padding: 0,
      marginRight: 0,
      gridColumn: '1 / -1',
    },
  },
  listingStatusHeading: {
    fontSize: '18px',
  },
  separation: {},
  arrow: {
    '@media screen and (max-width: 960px)': {
      width: '100%',
    },
  },
  topInfoContainer: {
    '@media screen and (max-width: 960px)': {
      flexDirection: 'column',
      alignItems: 'unset',
    },
  },
  idContainer: {
    '@media screen and (max-width: 960px)': {
      justifyContent: 'unset',
      padding: '12px 0',
    },
  },
  buttonContainer: {
    display: 'flex',
    gap: '16px',
    '@media screen and (max-width: 960px)': {
      justifyContent: 'unset',
    },
  },
  descriptionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
    fontSize: '22px',
    fontWeight: '500',
    color: '#000000',
    padding: '20px 0 20px 0',
    '@media screen and (max-width: 960px)': {
      flexDirection: 'column',
      alignItems: 'unset',
    },
  },
  documentsContainer: {
    margin: '0px 0px 14px 0px',
    flexDirection: 'row-reverse',
  },
  stepperHorizontal: {
    width: '100%',
  },
  detailsContainer: {
    zIndex: 0,
    backgroundColor: white,
    borderRadius: '4px 4px 4px 4px',
    margin: '0px 0px 14px 0px',
    padding: '14px 14px 14px 14px',
    boxShadow: `0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px rgba(0, 0, 0, 0.14),
    0px 1px 10px rgba(0, 0, 0, 0.12)`,
    transition: 'all 0.05s linear',
    '&:hover': {
      borderRadius: '4px 4px 4px 4px',
      boxShadow: `0px 4px 4px 4px rgba(0, 0, 0, 0.1),
      0px 8px 5px 4px rgba(0, 0, 0, 0.07),
      0px 2px 10px 4px rgba(0, 0, 0, 0.06)`,
      transition: 'all 0.05s linear',
      transform: 'scale(1.007, 1.007)',
      position: 'relative',
    },
    '@media screen and (max-width: 600px)': {
      maxWidth: '100%',
      minWidth: 0,
      '& > *': {
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
      },
    },
  },
  sidebarContainer: {},
  wellsContainerBid: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
  },
  bidWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    gap: '10px',
  },
  bidHeadingContainer: {
    backgroundColor: '#7890a6',
    padding: '13px',
    borderRadius: '8px 8px 0 0 ',
  },
  bottomWellContainer: {
    maxWidth: '33%',
    flexBasis: '33%',
  },
  bidSection: {
    borderLeft: 'solid 1px #000000',
    background: '#F9F9F9',
  },
  blueHeadingClone: {
    fontSize: '24px',
    lineHeight: '28px',
    fontWeight: 'bold',
  },
  wellAttrTitle: {
    lineHeight: '20px',
    marginBottom: '8px',
  },
  wellAttrValue: {
    lineHeight: '20px',
  },
  status: {
    marginTop: '8px',
  },
  bidContainer: {

    '@media screen and (max-width: 1280px)': {
      margin: '20px 0',
    },

    '@media screen and (max-width: 960px)': {
      margin: '12px 0',
    },

    '@media screen and (max-width: 600px)': {
      alignItems: 'center',
      padding: '32px 20px',
    },
  },
  bidHeading: {
    marginBottom: '16px',
    fontSize: '24px',
    lineHeight: '28px',
    fontWeight: 'normal',
    color: '#ffffff',

    '@media screen and (max-width: 600px)': {
      fontSize: '22px',
    },
  },

  bidStatValue: {
    marginTop: '8px',
    fontWeight: 'bold',
  },
  valuesByWell: {
    margin: '10px 0px',
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    boxShadow: 'unset',
    padding: '10px 30px',

    '&:hover': {
      backgroundColor: secondaryMain,
      color: white,
    },
  },
  bidButtonContainer: {
    display: 'flex',
  },
  amountContainer: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
    flexDirection: 'column',
  },
  wellAmountName: {
    fontSize: '18px',
    fontWeight: '500',
    height: 'calc(100% - 23px)',
    minWidth: '52px',
  },
  transactionNotificationText: {
    textAlign: 'center',
    fontSize: '18px',
  },
  infoIcon: {
    color: '#777777',
    height: 20,
    marginLeft: 5,
    width: 20,
    marginTop: 1,
  },
  infoIconCotainer: {
    display: 'flex',
  },
  downloadButton: {
    height: '52px',
    width: '220px',
    borderRadius: '8px',
    border: 'unset',
    outline: 'none',
    color: '#000',
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: '400',
    textAlign: 'center',
    textTransform: 'none',
    background: '#fff',
    boxShadow: 'unset',

    '&:hover': {
      backgroundColor: secondaryMain,
      color: white,
    },

    '@media screen and (max-width: 960px)': {
      marginTop: '20px',
    },

    '@media screen and (max-width: 600px)': {
      width: '100%',
      maxWidth: '100%',
      marginTop: 0,
    },
  },
};
